<template>
  <v-img v-bind="$attrs" v-on="$listeners" />
</template>

<script>
export default {
  name: "BaseFrontOfficeImage",
};
</script>
